import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { DomainDesignation } from "@constants";
import { centeredOffset } from "@utils/Directives/offset.js";
export default {
  directives: {
    centeredOffset
  },
  props: {
    domainIndicator: {
      type: Object,
      default() {
        return {};
      }
    },
    domain: {
      type: Object,
      default() {
        return {};
      }
    },
    fact: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      designation: {
        range: {
          min: 0,
          max: 0
        }
      }
    };
  },
  mounted() {
    this.setTheme();
  },
  computed: {
    factPossibleCount() {
      if (!this.fact) return 0;
      return this.fact.SurveysTaken ?? this.fact.PossibleCount;
    },
    isScored() {
      return !this.fact.IneligibilityReasonId && this.fact.IndicatorPointsEarned !== null;
    },
    percentile() {
      return Math.round(this.fact.IndicatorPointsEarned / this.domainIndicator.PointsPossible * 100);
    },
    performance() {
      return this.fact && !this.fact.IneligibilityReasonId && this.fact.PossibleCount > 0 ? Math.round(this.fact.MeetsCount / this.fact.PossibleCount * 100) : 0;
    },
    ineligibilityReason() {
      return this.$store.state.ineligibilityReasons.find(x => x.IneligibilityReasonId == this.fact.IneligibilityReasonId);
    },
    disclaimer() {
      return this.domainIndicator.Desclaimer != null ? this.domainIndicator.Desclaimer.replace("{year}", this.$store.getters.cycle.IPPCycleYear) : null;
    },
    detail() {
      // HACK: Forces computed property to update whenever the report years change
      // eslint-disable-next-line no-unused-vars
      let _ = this.$store.getters.reportYears;
      return this.formatDetail(this.domainIndicator.Detail);
    }
  },
  watch: {
    fact() {
      this.setTheme();
    }
  },
  methods: {
    setTheme() {
      let designation = DomainDesignation.noScore;
      for (let key in DomainDesignation) {
        if (typeof DomainDesignation[key] !== "object") {
          return;
        }
        if (DomainDesignation[key].range.min <= this.performance / 100 && DomainDesignation[key].range.max >= this.performance / 100) {
          designation = DomainDesignation[key];
          break;
        }
      }
      this.designation = !this.fact.IneligibilityReasonId ? designation : DomainDesignation.noScore;
    },
    showDisclaimer() {
      if (this.domainIndicator.CycleIds) {
        return this.domainIndicator.CycleIds.split(",").includes(String(this.$store.state.cycleId));
      }
      return false;
    },
    // HACK: Old method of displaying Detail resulted in the years being hardcoded, this whole method needs reworked but this will fix the years
    formatDetail(string) {
      // TODO: Possibly unnecessary escape characters
      // eslint-disable-next-line no-useless-escape
      let mergeCodeRegex = /\#\#(.*?)\#\#/g;
      let vue = this;
      if (mergeCodeRegex.test(string)) {
        let codes = string.match(mergeCodeRegex).map(x => {
          while (x.indexOf("#") > -1) {
            x = x.replace("#", "");
          }
          return x;
        });
        let results = {};
        for (let i = 0; i < codes.length; i++) {
          let code = codes[i];
          if (!results[`##${code}##`]) {
            switch (getCodeName(code)) {
              case "ReportYearSeries":
                {
                  let params = getParams(code);
                  results[`##${code}##`] = ReportYearSeries(params);
                  break;
                }
            }
          }
        }
        for (let key in results) {
          string = string.split(key).join(results[key]);
        }
      }
      return string;
      function getParams(code) {
        var paramRegex = /\((.*?)\)/g;
        let matches = code.match(paramRegex);
        return matches[0] ? eval(matches[0]) : {};
      }
      function getCodeName(code) {
        return code.split("(")[0];
      }
      function ReportYearSeries(params) {
        let reportYears = [];
        for (let i = 0; i < params.include.length; i++) {
          let targetIndex = params.include[i];
          let cycleYears = vue.$store.getters.reportYears;
          if (cycleYears.length > targetIndex) reportYears.push(vue.$store.getters.reportYears[targetIndex]);else return "";
        }
        if (reportYears.length == 0) return "";else if (reportYears.length == 1) return reportYears[0];else {
          let last = reportYears[reportYears.length - 1];
          reportYears.pop();
          return `${reportYears.join(", ")}${reportYears.length > 1 ? "," : ""} ${params.conjunction ? params.conjunction : "and"} ${last}`;
        }
      }
    }
  }
};